import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ISO42001DashboardPage = lazy(() =>
  import('../pages/iso42001').then((m) => ({ default: m.ISO42001DashboardPage }))
)
const ISO42001TemplatesPage = lazy(() =>
  import('../pages/iso42001').then((m) => ({ default: m.ISO42001TemplatesPage }))
)
const ISO42001TemplateEditorPage = lazy(() =>
  import('../pages/iso42001').then((m) => ({ default: m.ISO42001TemplateEditorPage }))
)
const ISO42001CreateAssessmentPage = lazy(() =>
  import('../pages/iso42001').then((m) => ({ default: m.ISO42001CreateAssessmentPage }))
)
const ISO42001RespondPage = lazy(() =>
  import('../pages/iso42001').then((m) => ({ default: m.ISO42001RespondPage }))
)
const ISO42001ConsolidationPage = lazy(() =>
  import('../pages/iso42001').then((m) => ({ default: m.ISO42001ConsolidationPage }))
)
const ISO42001ResultsPage = lazy(() =>
  import('../pages/iso42001').then((m) => ({ default: m.ISO42001ResultsPage }))
)
const ISO42001DimensionAnalysisPage = lazy(() =>
  import('../pages/iso42001').then((m) => ({ default: m.ISO42001DimensionAnalysisPage }))
)
const ISO42001SettingsPage = lazy(() =>
  import('../pages/iso42001').then((m) => ({ default: m.ISO42001SettingsPage }))
)

export const iso42001Routes: RouteObject[] = [
  {
    path: '/iso42001',
    children: [
      { index: true, element: <ISO42001DashboardPage /> },
      { path: 'dashboard', element: <ISO42001DashboardPage /> },
      { path: 'templates', element: <ISO42001TemplatesPage /> },
      { path: 'templates/new', element: <ISO42001TemplateEditorPage /> },
      { path: 'templates/:id', element: <ISO42001TemplateEditorPage /> },
      { path: 'create', element: <ISO42001CreateAssessmentPage /> },
      { path: 'respond/:id', element: <ISO42001RespondPage /> },
      { path: 'consolidation', element: <ISO42001ConsolidationPage /> },
      { path: 'results/:id', element: <ISO42001ResultsPage /> },
      { path: 'dimension', element: <ISO42001DimensionAnalysisPage /> },
      { path: 'dimension/:id', element: <ISO42001DimensionAnalysisPage /> },
      { path: 'settings', element: <ISO42001SettingsPage /> },
    ],
  },
]
